import { Button, ButtonStyles, PopupFooterProps } from '@silverfort/sf-components';
import { EntitiesSearchProps } from '../../EntitiesSearch/EntitiesSearch';
import { FC } from 'react';
import { EnrollmentEmailFormValues } from '../../../types/forms';

type State = Omit<EntitiesSearchProps, 'onSelectedEntitiesChange'> & { formValues?: EnrollmentEmailFormValues };

type EntitiesSearchFooterProps = PopupFooterProps<State> & {
    onDone: (state: State) => void;
    onAbort: (state: State) => void;
};

const EntitiesSearchFooter: FC<EntitiesSearchFooterProps> = ({ popupState, onDone, onAbort }) => {
    const handleCancel = () => {
        if (popupState) {
            onAbort(popupState);
        }
    };
    const handleSave = () => {
        if (popupState) {
            onDone(popupState);
        }
    };
    return (
        <div className="flex flex-1 justify-end gap-2 ">
            <Button buttonStyle={ButtonStyles.GhostSolid} text="Back" onClick={handleCancel} />
            <Button buttonStyle={ButtonStyles.PrimarySolid} text="Done" onClick={handleSave} />
        </div>
    );
};

export default EntitiesSearchFooter;
